import React from 'react';

import { useFulfillmentPlannerContext } from '../context';

import DeliveryTime from './index';

const FulfillmentPlannerContextDeliveryTimeContainer = ({ className }) => {
  const { deliveryTime } = useFulfillmentPlannerContext();

  return <DeliveryTime className={className} deliveryTime={deliveryTime} emptyValue='--' />;
};

export default FulfillmentPlannerContextDeliveryTimeContainer;
